import { useEffect } from 'react';
import Router, { useRouter } from 'next/router';
import NProgress from 'nprogress';

import { routeVar } from 'store/route';
import { globalSearchVar } from 'store/search';

import { trackAnalyticsData, AnalyticsEvent } from 'utils/analytics';

export default function PageChangeObserver() {
  const { asPath } = useRouter();

  useEffect(() => {
    const delay = 300;
    let timer: NodeJS.Timeout;

    const handleRouteChangeStart = () => {
      timer = setTimeout(() => {
        NProgress.start();
      }, delay);

      if (!window.location.pathname.includes('/search')) {
        routeVar({
          prevPath: window.location.pathname,
        });
      }
    };

    const handleRouteChangeStop = (url: string) => {
      clearTimeout(timer);
      NProgress.done();

      if (!url.includes('/search')) {
        globalSearchVar({ phrase: '' });
      }
      trackAnalyticsData(AnalyticsEvent.PAGE_CHANGE, { url });
    };

    Router.events.on('routeChangeStart', handleRouteChangeStart);
    Router.events.on('routeChangeComplete', handleRouteChangeStop);
    Router.events.on('routeChangeError', handleRouteChangeStop);

    setTimeout(() => {
      trackAnalyticsData(AnalyticsEvent.PAGE_LOADED, { url: asPath });
    }, 0);
  }, []);

  return null;
}
